import { useContext, useEffect } from "react";
import { TitleContext } from "../components/Context";
import LegacyDashboard from "../components/Dashboard/LegacyDashboard";

export default function LegacyDashboardPage() {
  const { setTitle } = useContext(TitleContext);

  useEffect(() => {
    setTitle("Observatorio clásico");
  }, [setTitle]);

  return <LegacyDashboard />;
}
